import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import Fade from '@material-ui/core/Fade';
import { withRouter } from 'react-router-dom';
import ContentService from '../../../apiclients/ContentService';
import PrintService from '../../../apiclients/PrintService';
import AppContext from '../../../AppContext';
import LocalizedStrings from '../../Localization/localization';
import { createShareLink } from '../../../helpers';
import NewPDFViewer from '../../Viewers/NewPDFViewer/NewPDFViewer';
import { withStyles } from '@material-ui/core/styles';

const Transition = React.forwardRef((props, ref) => <Fade {...props} ref={ref} />);
const styles = (theme) => ({
    root: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)!important',
        overflow: 'hidden',
    },
});
class DownloadPDFMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            downloadURL: undefined,
            language: 'en',
        };
    }

    handleClick = async () => {
        if (this.state.downloadURL === undefined) {
            let appContext = new AppContext();
            let platformConfig = appContext.getPlatformConfig();
            this.setState({ language: appContext.getLanguage() });
            let tempInDays = platformConfig.shareExpireInDays ? platformConfig.shareExpireInDays : 30;
            let now = new Date();
            let expireDate = now.setDate(now.getDate() + tempInDays);

            this.setState({ loading: true });
            let ids = [];
            if (this.props.currentContent.children) {
                ids = this.props.currentContent.children;
            }
            ids.push(this.props.currentContent.contentId);
            try {
                const data = await ContentService.shareContent(this.props.currentContent.shareURL, ids, expireDate);
                const url = createShareLink(
                    this.props.currentContent.contentId,
                    this.props.currentContent.contentType,
                    this.props.currentContent.name,
                    data.shareToken
                );
                const { downloadURL } = await PrintService.printURL(url, this.props.currentContent.name);
                this.setState({ shareToken: data.shareToken, downloadURL, loading: false, open: true });

                // TODO: Localize this error
            } catch (err) {
                this.props.notify('error', LocalizedStrings.errorShareLink);
                this.setState({ loading: false });
            }
        } else {
            this.setState({ open: true });
        }
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    render() {
        return (
            <>
                <div data-id="download-pdf-inside" style={this.props.children ? { display: 'inline-block' } : undefined}>
                    {this.props.children && (
                        <div style={{ display: 'inline-block' }} onClick={this.handleClick}>
                            {this.props.children(this.state.loading)}
                        </div>
                    )}
                </div>
                <Dialog
                    fullScreen={true}
                    open={this.state.downloadURL !== undefined && this.state.open}
                    onClose={this.handleClose}
                    TransitionComponent={Transition}
                    PaperProps={{
                        classes: {
                            root: this.props.classes.root,
                        },
                    }}
                    BackdropProps={{
                        classes: {
                            root: this.props.classes.root,
                        },
                    }}
                >
                    {this.state.downloadURL !== undefined && (
                        <NewPDFViewer
                            url={this.state.downloadURL}
                            language={this.state.language}
                            shareable={true}
                            onClose={this.handleClose}
                        />
                    )}
                </Dialog>
            </>
        );
    }
}
DownloadPDFMenu.propTypes = {
    currentContent: PropTypes.object,
    notify: PropTypes.func.isRequired,
    children: PropTypes.func,
};
const DownloadPDF = withRouter(DownloadPDFMenu);

export default withStyles(styles)(DownloadPDF);
